import React, { useEffect } from 'react';
import { Dialog } from "@material-ui/core";
import "./index.scss";
import { Button } from "../../Button";
import { ErrorDialogType } from "../../../utils/hooks/useErrorDialog";
import { strings } from "../../../strings/strings";

interface Props {
    type: ErrorDialogType;
    text: string;
    open: boolean;
    onClickListener?: () => void;
    textDetail?: string;
}

export const ErrorMessageDialog = ({type, text, open, onClickListener, textDetail}: Props) => {

    useEffect(() => {
        if (textDetail && open) console.log(textDetail);
    }, [textDetail, open]);

    const onClickHandler = () => {
        if (onClickListener) {
            onClickListener();
        }
    };

    const getDialogTitle = () => {
        switch (type) {
            case ErrorDialogType.ERROR:
                return strings.error;
            case ErrorDialogType.WARNING:
                return strings.warning;
            case ErrorDialogType.NONE:
                return '';
            default:
                return strings.error;
        }
    }

    return (
        <Dialog open={open}
                disableBackdropClick={true}
                onBackdropClick={onClickHandler}>
            <div className={"vs-er-dialog vs-dialog_not-found"}>
                <div className={"vs-er-dialog__content fluid"}>

                    <span className={"vs-er-dialog__content__title"}>{getDialogTitle()}</span>

                    <p className={"vs-er-dialog__content__text"}>
                        {text}
                    </p>

                    <div className={"vs-er-dialog__content__button"}>
                        <Button label={strings.errorMessageDialog.btnGood} onClickListener={onClickHandler}/>
                    </div>

                </div>
            </div>
        </Dialog>
    )
};

